import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as constants from 'constants/redux/conversation';

const getArchivedMsg = ({ showArchivedMsg, tags }) => {
  if (!showArchivedMsg) {
    return {};
  }

  return {
    code: tags.find(({ id }) => id === 3) ? 'conversationArchived' : 'conversationUnarchived',
  };
};

const initialState = {
  isFetching: false,
  data: {},
  id: null,
  error: null,
  uploadError: null,
  success: null,
  isPosting: false,
};

const setFetchConversationRequest = (state) =>
  update(state, {
    isFetching: { $set: true },
    data: { $set: {} },
  });

const setFetchConversationSuccess = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    data: { $set: action.payload },
    error: { $set: {} },
    id: { $set: action.payload.id },
  });

const setFetchConversationFailure = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    data: { $set: {} },
    error: { $set: action.payload.error },
  });

const clearConversation = (state) =>
  update(state, {
    error: { $set: {} },
    uploadError: { $set: {} },
    success: { $set: null },
  });

// Clears only the just-viewed pointer, leaving `data` and the flags alone.
// Dispatched by the conversations list once it has consumed the pointer for
// scroll restore. Deliberately separate from clearConversation: that one runs
// on conversation-view unmount, which is exactly when the list still needs it.
const clearPreviousConversation = (state) =>
  update(state, {
    id: { $set: null },
  });

const conversationUploadFileSuccess = (state) =>
  update(state, {
    success: { $set: { code: 'imageUploaded' } },
  });

const conversationUploadFileFailure = (state, action) => {
  const err = (action.payload && action.payload.error) || {};
  return update(state, {
    uploadError: { $set: { ...err, message: err.message || 'Unable to upload the file.' } },
  });
};

const conversationUploadFileIdle = (state) =>
  update(state, {
    success: { $set: null },
    uploadError: { $set: null },
  });

const postMessageRequest = (state) =>
  update(state, {
    isFetching: { $set: true },
    isPosting: { $set: true },
    error: { $set: {} },
  });

const postMessageSuccess = (state) =>
  update(state, {
    isPosting: { $set: false },
    // data: { $set: {...state.data, Messages: state.data.Messages.concat(action.payload) } }
    // We can consider this option as it has the benefit of quicker update.
  });

const postMessageFailure = (state, action) =>
  update(state, {
    // isPosting: { $set: false },
    viewId: { $set: 0 },
    error: { $set: action.payload.error },
  });

const deleteMessageRequest = (state) =>
  update(state, {
    isFetching: { $set: true },
    error: { $set: {} },
  });

const deleteMessageSuccess = (state) =>
  update(state, {
    isFetching: { $set: false },
    error: { $set: {} },
  });

const deleteMessageFailure = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    error: { $set: action.payload.error },
  });

const setPostConversationTagsRequest = (state) =>
  update(state, {
    isPosting: { $set: true },
    error: { $set: {} },
  });

const setPostConversationTagsSuccess = (state, action) =>
  update(state, {
    isPosting: { $set: false },
    error: { $set: {} },
    success: {
      $set: getArchivedMsg(action.payload),
    },
    data: { $set: { ...state.data, tags: action.payload.tags } },
  });

const setPostConversationTagsFailure = (state, action) =>
  update(state, {
    isPosting: { $set: false },
    error: { $set: action.payload.error },
  });

const updateConversationReview = (state, action) =>
  update(state, {
    data: {
      $set: {
        ...state.data,
        HostReview: action.payload,
      },
    },
  });

export default handleActions(
  {
    [constants.FETCH_CONVERSATION_REQUEST]: setFetchConversationRequest,
    [constants.FETCH_CONVERSATION_SUCCESS]: setFetchConversationSuccess,
    [constants.FETCH_CONVERSATION_FAILURE]: setFetchConversationFailure,

    [constants.CLEAR_CONVERSATION]: clearConversation,
    [constants.CLEAR_PREVIOUS_CONVERSATION]: clearPreviousConversation,

    [constants.CONVERSATION_UPLOAD_FILE_SUCCESS]: conversationUploadFileSuccess,
    [constants.CONVERSATION_UPLOAD_FILE_FAILURE]: conversationUploadFileFailure,
    [constants.CONVERSATION_UPLOAD_FILE_IDLE]: conversationUploadFileIdle,

    [constants.POST_MESSAGE_REQUEST]: postMessageRequest,
    [constants.POST_MESSAGE_SUCCESS]: postMessageSuccess,
    [constants.POST_MESSAGE_FAILURE]: postMessageFailure,

    [constants.DELETE_MESSAGE_REQUEST]: deleteMessageRequest,
    [constants.DELETE_MESSAGE_SUCCESS]: deleteMessageSuccess,
    [constants.DELETE_MESSAGE_FAILURE]: deleteMessageFailure,

    [constants.POST_CONVERSATION_TAGS_REQUEST]: setPostConversationTagsRequest,
    [constants.POST_CONVERSATION_TAGS_SUCCESS]: setPostConversationTagsSuccess,
    [constants.POST_CONVERSATION_TAGS_FAILURE]: setPostConversationTagsFailure,

    [constants.UPDATE_CONVERSATION_REVIEW]: updateConversationReview,
  },
  initialState,
);
